<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist' :style="{position:absolute,top:0,bottom:0,overflow:disShow?'hidden':'auto'}">
                    <div class="q_title">响应详情</div>
                    <div class="mainSty">
                        <div v-for="(item,index) in itemList" :key="index" class="blkmt">
                            <detailList :item="item"></detailList>
                        </div>
                    </div>
                    <div class="q_title">支持信息</div>
                    <div class="mainSty blkmt">
                        <div v-for="(item,index) in itemList2" :key="index" class="blkmt">
                            <detailList :item="item"></detailList>
                        </div>
                    </div>
                    <div class="blkhj" style="display:flex">
                        <div class="blkgu">
                            <!-- <div class="btnu">
								<button class="btnu" style="border:none;background:none;color:#0080ff;width:100%;height:100%" :disabled="disabled1" @click="close">关闭</button>
							</div> -->
                            <div class="btnu1">
                                <button class="btnu" style="background:none;width:100%;border:none;height:100%" :disabled="disabled" @click="confirm">确认完成</button>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="disShow" style="width:100%;height:100%;z-index:3000">
						<div ref="dig" class="mtblks" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
							<div class="dialogs1">
								<div class="digtxt">确认关闭响应支持吗</div>
								<div class="txtx" @click="reback"><img src="./image/x@2x.png" style="position:absolute;top:0;right:0;width:100%;height:100%"></img></div>
								<div class="c" style="display:flex;align-items:center;justify-content:center">
									<div class="reback" @click="reback">返回</div>
									<div class="submit" @click="submit1">确定</div>
								</div>
							</div>
						</div>
					</div> -->
                    <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
                    <van-dialog v-model:show="disShow" @cancel="reback" @confirm="submit1" confirm-button-color="#108EE9" show-cancel-button>
                        <div class="digtxt3">
                            <img src="../../components/image/error.png" alt="" style="width: 35%;padding-top: 25px;">
                            <div style="padding: 20px 0;">确认关闭响应支持</div>
                            <!-- <van-field v-model="reasons" style="border:1px solid #eee" rows="3" autosize type="textarea" placeholder="请输入关闭原因" /> -->
                        </div>
                    </van-dialog>

                </div>
            </div>
        </div>
    </div>

</template>
<script>
import customToast from "@/components/toast.vue";
import detailList from "@/components/detailList";
export default {
    components: { detailList, customToast },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            itemList: [
                {
                    tit: "响应编号",
                    subtit: "",
                },
                {
                    tit: "资产所属人：",
                    subtit: "",
                },
                {
                    tit: "联系电话：",
                    subtit: "",
                },
                {
                    tit: "用户单位",
                    subtit: "",
                },
                {
                    tit: "部门（办公室）：",
                    subtit: "",
                },
                {
                    tit: "提交时间：",
                    subtit: "",
                },
                {
                    tit: "所属分类：",
                    subtit: "",
                },
            ],
            eng: "",
            tel: "",
            itemList2: [
                {
                    tit: "工程师：",
                    subtit: "",
                },
                {
                    tit: "联系电话：",
                    subtit: "",
                },
                {
                    tit: "公司：",
                    subtit: "",
                },
                {
                    tit: "组别：",
                    subtit: "",
                },
                {
                    tit: "最迟解决时间：",
                    subtit: "",
                },
                {
                    tit: "实际完成时间：",
                    subtit: "",
                },
            ],
            disabled: false,
            disabled1: false,
            disShow: false,
        };
    },
    methods: {
        close() {
            this.disShow = true;
        },
        reback() {
            this.disShow = false;
        },
        submit1() {
            this.disabled1 = true;
            let data = {
                recordId: this.$route.query.recordId,
            };
            this.$api
                .get("/app/support/deleteSupport", { params: data })
                .then((res) => {
                    this.disabled1 = false;
                    if (res.data.code == "0000") {
                        this.disShow = false;
                        // this.$toasts("关闭成功");
                        this.toastRow = {
                            selId: 3,
                            title: "成功关闭",
                            text: "您已成功关闭响应支持",
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                        if (this.$route.query.froms == 1) {
                            setTimeout(() => {
                                this.$router.push("/responseDetail");
                            }, 1000);
                        } else {
                            setTimeout(() => {
                                this.$router.push({ path: "/index" });
                            }, 1000);
                        }
                    }
                });
        },
        getData() {
            let data = { recordId: this.$route.query.recordId };
            this.$api
                .get("/app/support/getSupportRecordDetailInfo", {
                    params: data,
                })
                .then((res) => {
                    // data.maintenanceTime=data.maintenanceTime?this.dayjs(data.maintenanceTime).format("YYYY-MM-DD HH:mm:ss"):'';
                    data.responseType =
                        data.responseType == 1 ? "硬件报修" : "软件报修";
                    if (res.data.code == "0000") {
                        let data = res.data.data;
                        // data.maintenanceTime=data.maintenanceTime?this.dayjs(data.maintenanceTime).format("YYYY-MM-DD HH:mm:ss"):'';
                        let length = data.recordId.toString().length;
                        if (length == 1) {
                            data.recordId = `HGSL-00000${data.recordId}(R)`;
                        } else if (length == 2) {
                            data.recordId = `HGSL-0000${data.recordId}(R)`;
                        } else if (length == 3) {
                            data.recordId = `HGSL-000${data.recordId}(R)`;
                        } else if (length == 4) {
                            data.recordId = `HGSL-00${data.recordId}(R)`;
                        } else if (length == 5) {
                            data.recordId = `HGSL-0${data.recordId}(R)`;
                        } else if (length == 6) {
                            data.recordId = `HGSL-${data.recordId}(R)`;
                        } else if (length > 6) {
                            data.recordId = `HGSL-${data.recordId}(R)`;
                        }
                        this.itemList = [
                            {
                                tit: "响应编号",
                                subtit: data.recordId,
                            },
                            {
                                tit: "资产所属人：",
                                subtit: data.dutyName,
                            },
                            {
                                tit: "联系电话：",
                                subtit: data.maintenanceTel,
                            },
                            {
                                tit: "用户单位",
                                subtit: data.maintenanceCompanyName,
                            },
                            {
                                tit: "部门（办公室）：",
                                subtit: data.maintenanceOffice,
                            },
                            {
                                tit: "提交时间：",
                                subtit: data.maintenanceTime,
                            },
                            {
                                tit: "所属分类：",
                                subtit:
                                    data.responseType == 1
                                        ? "硬件报修"
                                        : "软件报修",
                            },
                        ];
                        let datay = data.engineerFinishTime
                            ? this.dayjs(data.engineerFinishTime).format(
                                  "YYYY-MM-DD HH:mm:ss"
                              )
                            : "";
                        this.eng = data.engineerName;
                        this.tel = data.engineerTel;
                        if (data.group == 0) {
                            data.group = "机动组";
                        } else if (data.group == 1) {
                            data.group = "驻场组";
                        } else {
                            data.group = "";
                        }
                        this.itemList2 = [
                            {
                                tit: "工程师：",
                                subtit: data.engineerName,
                            },
                            {
                                tit: "联系电话：",
                                subtit: data.engineerTel,
                            },
                            {
                                tit: "公司：",
                                subtit: data.engineerCompanyName,
                            },
                            {
                                tit: "组别：",
                                subtit: data.group,
                            },
                            {
                                tit: "最迟解决时间：",
                                subtit: data.lastFinishTime,
                            },
                            {
                                tit: "实际完成时间：",
                                subtit: data.engineerFinishTime,
                            },
                        ];
                    } else {
                        this.datas = [];
                    }
                });
        },
        confirm() {
            this.disabled = true;
            let data = {
                // "engineerId": this.$route.query.engineerId,
                recordId: this.$route.query.recordId,
            };
            this.$api
                .get("/app/support/supportFinish", { params: data })
                .then((res) => {
                    this.disabled = false;
                    if (res.data.code == "0000" && res.data.message == "成功") {
                        this.$router.push({
                            path: "/estimate",
                            query: {
                                recordId: this.$route.query.recordId,
                                froms: this.$route.query.froms,
                                eng: this.eng,
                                tel: this.tel,
                            },
                        });
                    }
                });
        },
    },
    created() {
        this.getData();
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
::v-deep .van-field__value {
    overflow: auto;
}
::v-deep .van-field {
    max-height: 200px;
    height: auto !important;
}
.digtxt3 {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
    /* margin-bottom: 54px; */
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
button {
    border: none;
    padding: 0;
    margin: 0;
}
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #e9eef2;
    overflow-x: hidden;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 100%;
}
.mainSty {
    width: 303px;
    height: 300x;
    padding: 14px 21px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-top: 20px;
}
.q_title {
    width: 345px;
    height: 20px;
    margin: 15px auto;
    font-size: 16px;
    font-weight: 700;
    color: #222222;
}
.blkmt {
    margin-top: 20px;
}
.blkhj {
    width: 100%;
    height: 44px;
}
.blkgu {
    width: 281px;
    height: 44px;
    margin: 20px auto;
}
/* .btnu{
        width:100%;height:100%;background: linear-gradient(116deg,#36b3fe 11%, #0080ff 91%);border-radius:22px;font-size: 16px;font-weight: 400;text-align: center;line-height:44px;color: #ffffff;
    } */

.blkhj {
    width: 100%;
    height: 44px;
}
.blkgu {
    width: 300px;
    height: 44px;
    margin: 20px auto;
    display: flex;
}
.btnu {
    margin-right: 10px;
    border: 2px solid #0080ff;
    flex: 0 0 140px;
    height: 100%;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 44px;
    color: #ffffff;
}
button {
    border: none;
}
.btnu1 {
    margin-left: 10px;
    flex: 0 0 281px;
    height: 100%;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 44px;
    color: #ffffff;
}
.dialogs1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 189px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.digtxt1 {
    width: 200px;
    height: 28px;
    margin: 24px auto;
    margin-bottom: 54px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
    margin-left: 20px;
}
</style>
